'use client';

import { c as _c } from "react/compiler-runtime";
import { getLocale } from '@libs/core';
import { HeaderMini } from '../HeaderMini';
import GlobalErrorBody from './GlobalErrorBody';
import type { GlobalErrorProps } from './types';

// Used in src/app/global-error.tsx
export default function GlobalErrorPage(t0) {
  const $ = _c(6);
  const {
    reset,
    error
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getLocale();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const currentLocale = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <head><title>Global Error Page</title></head>;
    t3 = <HeaderMini />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== error || $[4] !== reset) {
    t4 = <html lang={currentLocale}>{t2}<body>{t3}<GlobalErrorBody reset={reset} error={error} /></body></html>;
    $[3] = error;
    $[4] = reset;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}